export default __webpack_public_path__ + "static/media/deer.79490bc0.png";